import { RandomisationStatusContentModel } from '../generated/types/RandomisationStatusContentModel';

const randomizationStatusContentModelMock: RandomisationStatusContentModel = {
  title: 'CMS ONLY',
  status_date: '[M]Entered/Randomised Date',
  status_period: '[M]Entered/Randomised Period',
  date_input_warning:
    "Make sure to enter the right Entered/Randomised date. It won't be possible to edit the Entered/Randomised date once the patient has accepted their account on the Unify app.",
  status_metric_title: '[M]Entered/Randomised',
  status_value_name: '[M]Entered/Randomised',
  status_metric_description_md: `**Entered/Randomized**

The actual vs planned number of entered/randomized patients in the study. See "Last synch: date and time" for when data was updated.
`,
  uid: 'blt7fc9f1897d1f56d2',
  _content_type_uid: 'randomisation_status',
};

const create = (partial?: Partial<RandomisationStatusContentModel>): RandomisationStatusContentModel => ({
  ...randomizationStatusContentModelMock,
  ...partial,
});

export const RandomisationStatusContentModelMock = {
  create,
};
